export default "__VITE_ASSET__XDmy945H__"